<template>
  <div class="video-page" @touchmove="touchmove">
    <meta name="referrer" content="never" />
    <template v-if="[1, 2, 3, 4, 5].includes(data.info?.isExpired)">
      <div class="masker"></div>
      <div class="expire-card">
        <div class="center">
          <div class="title">{{ linkStautsInfo.title }}</div>
          <div class="desc">{{ linkStautsInfo.desc }}</div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="video-section">
        <div class="video-box">
          <video
            id="courseVideo"
            :src="data.info?.url"
            :poster="data.info?.cover"
            controls
          >
          </video>
          <div class="remain-time">{{ data.videoDuration }}</div>
          <img class="play-icon" src="../../assets/play_icon.png" alt="" v-if="!isPlay" @click="onVideoPlay">
        </div>
        <div class="title">{{ data.info?.title }}</div>
        <div class="create-time">截止时间：{{ data.info.endTime?.replace("T", " ") }}</div>
      </div>
    </template>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { defineComponent, reactive, onMounted, computed } from "vue"; 
import { getVideoInfoV2 } from "@/request/course";
import { getStorage } from "../../utils/auth.js";
import { useCustomVideoPlayer } from './useVideoTimeTracker';

export default defineComponent({
  name: "videoWatch2",
  setup() {
    const router = useRouter();
    let query = router.currentRoute.value.query;
    console.log("query: ", query);

    const data = reactive({
      info: {},
      userInfo: {},
      isLogin: !!getStorage("info"),
      auditStatus: null, // 0审核中 1审核通过 2黑名单
      isPlayFinish: false,
      questionInfo: {},
      options: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "G", "K", "L"],
      isLoading: false,
      videoDuration: "",
      duration: '',
      currentTime: '',
      username: "",
      phone: '',
      isShowRemarkDialog: false,
      isShowVersion: false,
    });

    const statusMap = {
      1: { title: '链接已过期', desc: '请联系客服了解详情' },
      2: { title: '课程已结束', desc: '请联系客服了解详情' },
      3: { title: '暂无权限', desc: '请联系其他同事' },
      4: { title: '课程未开始', desc: '请联系客服了解详情' },
      5: { title: 'CDN流量已用完', desc: '请联系客服了解详情' }
    }
    const linkStautsInfo = computed(() => {
      return statusMap[data.info?.isExpired] || {};
    });

    // 获取视频信息
    const getVideoDetailInfo = async () => {
      try {
        const res = await getVideoInfoV2(query.key);
        console.log('获取视频信息：', res)
        if (res.code === 200) {
          data.info = { ...res.data }
        }
      } catch (error) {
        console.log('请求出错：', error);
      }
    }

    onMounted(() => {
      document.title = '学习中心';
      getVideoDetailInfo();
    })

    const touchmove = (e) => {
      if (!data.isLogin || data.isShowRemarkDialog) {
        e.preventDefault();
      }
    };

    const { isPlay, onVideoPlay, onFullScreen } = useCustomVideoPlayer('#courseVideo', data)

    return {
      touchmove,
      data,
      linkStautsInfo,
      query,
      isPlay,
      onVideoPlay,
      onFullScreen,
    };
  },
  beforeUnmount() {
    window.removeEventListener("scroll", () => {});
  },
});
</script>

<style lang="scss" scope>
html,
body,
#app {
  height: 100%;
}

.video-page {
  position: relative;
  height: 100vh;
  background-color: #F7F7F7;
  overflow-y: auto;

  .version {
    margin-top: 30px;
    text-align: center;

    .version-row {
      margin-bottom: 10px;
    }
  }
}

.video-section {
  padding: 20px 15px;
  background-color: #fff;
  margin-bottom: 8px;

  .top-userInfo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    .avatar {
      width: 45px;
      height: 45px;
      border-radius: 50%;
      margin-right: 10px;
    }
    .nickname, .userId {
      font-size: 14px;
    }

    .copyLink {
      color: #3478F6;
      font-size: 14px;
    }
  }

  .video-box {
    position: relative;
    width: 100%;
    height: 210px;
    background-color: #000;
  }

  #courseVideo {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;

    &::--webkit-media-controls {
      display: none!important;
    }
  }

  .play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 60px;
    height: 60px;
  }

  .fullscreen {
    position: absolute;
    right: 10px;
    bottom: 10px;
    width: 30px;
    height: 30px;
  }

  .remain-time {
    position: absolute;
    top: 15px;
    right: 15px;
    color: #333333;
    font-size: 18px;
  }

  .title {
    font-weight: bold;
    font-size: 16px;
    line-height: 28px;
    color: #333333;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-bottom: 4px;
    margin-top: 12px;
  }

  .create-time {
    font-weight: 400;
    font-size: 12px;
    color: #666666;
    line-height: 17px;
  }
}

.answer-section {
  background-color: #fff;

  .header {
    display: flex;
    align-items: center;
    padding: 12px 15px;
    border-bottom: 1px solid #F2F2F4;
    color: #EA5427;
    font-size: 14px;
    line-height: 20px;

    .money {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }

  .content {
    padding: 20px 15px;

    .question {
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      font-weight: bold;
      margin-bottom: 12px;
    }

    .answer-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 40px;
      padding: 0 12px;
      box-sizing: border-box;
      background: #F5F7FA;
      border-radius: 4px 4px 4px 4px;
      font-size: 14px;
      overflow: hidden;

      .checked {
        width: 14px;
        height: 14px;
      }

      .text-ellipsis {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      &:not(:last-of-type) {
        margin-bottom: 4px;
      }

      &.active {
        background-color: #DCE7FA;
        color: #3478F6;
        font-weight: bold;
      }

      &.fail {
        background-color: #FFE6DD;
        color: #EA5427;
      }
    }
  }
}

.control-box {
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
  padding-bottom: 20px;

  .submit-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 34px;
    background: #3478F6;
    border-radius: 17px 17px 17px 17px;
    text-align: center;
    line-height: 34px;
    color: #fff;

    .refresh {
      width: 14px;
      height: 14px;
      margin-right: 8px;
    }

    &.disabled {
      background: rgba(52, 120, 246, .6)
    }

    &.fail {
      background: #EA5427;
    }
  }
}

.answer-placeholder {
  width: 100%;
  height: 44px;
  font-size: 14px;
  color: #666666;
  line-height: 44px;
  text-align: center;
  background-color: #fff;
}

.masker {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(0, 0, 0, .5);
}

.video-card {
  position: absolute;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
  width: 289px;
  height: 302px;
  background: #FAFBFC;
  border-radius: 20px 20px 20px 20px;
  padding: 32px 20px;
  box-sizing: border-box;

  img {
    width: 249px;
    height: 152px;
    display: block;
    margin-bottom: 8px;
    object-fit: cover;
  }

  .title {
    font-size: 14px;
    color: #333333;
    text-align: center;
    margin-bottom: 32px;
  }

  .learn-btn {
    width: 249px;
    height: 34px;
    background: #3478F6;
    border-radius: 17px 17px 17px 17px;
    color: #fff;
    text-align: center;
    line-height: 34px;;
  }

}

.apply-card {
  position: absolute;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
  width: 299px;
  height: 345px;
  background: url(../../assets/apply-dialog.png) no-repeat;

  &.black-card {
    background-image: url(../../assets/black-dialog.png);
  }

  .center {
    position: absolute;
    top: 140px;
    left: 50%;
    width: 100%;
    transform: translateX(-50%);
  }

  .title {
    font-size: 26px;
    color: #333;
    font-weight: bold;
    text-align: center;
  }

  .desc {
    font-size: 14px;
    color: #333333;
    line-height: 21px;
    text-align: center;
    margin-top: 4px;
  }

  .user-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 24px;

    .avatar {
      width: 55px;
      height: 55px;
      box-shadow: 0px 3px 6px 1px rgba(91,116,165,0.16);
      border: 3px solid #FFFFFF;
      border-radius: 50%;
    }

    .nickname {
      font-size: 16px;
      color: #333333;
      line-height: 21px;
      text-align: center;
      margin-top: 8px;
      font-weight: bold;
    }
  }
}

.expire-card {
  position: absolute;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
  width: 299px;
  height: 265px;
  background: url(../../assets/expire-dialog.png) no-repeat;

  .center {
    position: absolute;
    top: 156px;
    left: 50%;
    transform: translateX(-50%);
  }

  .title {
    font-size: 26px;
    color: #333;
    font-weight: bold;
    text-align: center;
    white-space: nowrap;
  }

  .desc {
    font-size: 14px;
    color: #333333;
    line-height: 21px;
    text-align: center;
    margin-top: 4px;
  }
}

.finish-page {
  text-align: center;

  img {
    width: 100%;
    display: block;
  }

  .title {
    font-size: 20px;
    color: #333;
    text-align: center;
    margin-top: 32px;
  }

  .text-center {
    display: flex;
    justify-content: center;
  }

  .desc {
    max-width: 210px;
    font-size: 14px;
    color: #333333;
    line-height: 21px;
    text-align: center;
    margin-top: 8px;

    &.w112 {
      max-width: 112px;
    }
  }
}

.loading-card {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.flex-center,
.flex-start {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.flex-start {
  justify-content: flex-start;
}

.remark-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 295px;
  height: 330px;
  // height: 398px;
  background-color: #FFFFFF;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    font-size: 16px;
    color: #333333;
    margin: 24px 0;
  }
  
  .avatar {
    width: 42px;
    height: 42px;
    margin-bottom: 6px;
    border-radius: 50%;
    overflow: hidden;
  }
  
  .nickname {
    font-size: 14px;
    color: #333;
  }
  
  .form {
    width: 265px;
    margin-top: 44px;
  }
  
  .form-item {
    margin-bottom: 12px;
  }
  
  .form-item2 {
    margin-bottom: 32px;
  }
  
  .text {
    font-size: 12px;
    color: #666;
    margin-bottom: 6px;
  }
  
  .input {
    width: 100%;
    padding: 0 12px;
    box-sizing: border-box;
    height: 36px;
    background-color: #EDF2FA;
    border-radius: 4px;
    color: #333333;
    font-size: 14px;
    border: none;
  }
  
  .btn-item {
    height: 34px;
    background: #FFFFFF;
    border-radius: 17px;
    padding: 0 50px;
    border: 1px solid #446CE2;
    text-align: center;
    line-height: 34px;
    color: #3478F6;
    font-size: 13px;
  }
  
  .save-btn {
    background: #3478F6;
    color: #fff;
    // margin-left: 13px;
  }
}

.redPacket {
  width: 100%;
  height: 449px;
  position: relative;
  margin-top: 15px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .money-center {
    position: absolute;
    top: 132px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    color: #EA5427;

    .money-text {
      font-size: 64px;
      line-height: 70px;
      font-weight: bold;
      margin-right: 8px;
    }

    .unit {
      position: relative;
      bottom: -10px;
      font-size: 24px;
      line-height: 70px;
    }
  }

  .money-tips {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 270px;
    width: 210px;
    height: 42px;
    font-weight: 400;
    font-size: 14px;
    color: #FDF4BC;
    line-height: 22px;
    text-align: center;
  }

  .collect-money {
    position: absolute;
    top: 328px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 23px;
    line-height: 22px;
    color: #FAE14D;
    text-align: center;
  }
}
</style>
